<template>
  <!-- The Modal -->
  <div id="LoadingModal" class="loading-modal">

    <!-- Modal content -->
    <div class="loading-modal-content">
      <p class="text-center font-weight-bold text-onload"></p>
<!--      <div class="linear-load" :style="{background: `url(${loadingImg})`}"></div>-->
      <div class="linear-load"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadPDFLoading'
};
</script>

<style scoped>
/* The Modal (background) */
.loading-modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100; /* Sit on top */
  padding: calc(50vh - 92px); /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
/* Modal Content */
.loading-modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 350px;
  border-radius: 5px;
}
.linear-load {
  width: 100%;
  height: 15px;
  background: #f1b1b5;
  border-radius: 10px;
  transform: translate(0);
}
.linear-load::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 1%;
  height: 100%;
  background: #dc3e49;
  border-radius: 10px;
  animation: animate 20s linear forwards;
}
.text-onload::before {
  content: 'Requesting To Download . . .';
  animation: change-text 15s forwards;
}
@keyframes animate {
  0% {
    width: 0%;
  }
  1%{
    width: 5%;
  }
  100% {
    width: 98.5%;
  }
  0% {
    width: 98.5%;
  }
}
@keyframes change-text {
  75% {
    content: "Fetching Data . . .";
  }

  100% {
    content: "Converting To PDF . . .";
  }
}
</style>
